import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const CaesarCipher = () => {
  const [text, setText] = useState("");
  const [shift, setShift] = useState(3);
  const [result, setResult] = useState("");

  const caesarCipher = (str, shift, decrypt = false) => {
    return str
      .split("")
      .map((char) => {
        if (char.match(/[a-z]/i)) {
          const code = char.charCodeAt(0);
          const isUpperCase = code >= 65 && code <= 90;
          let shiftAmount = shift % 26;
          if (decrypt) shiftAmount = 26 - shiftAmount;
          let shiftedCode = code + shiftAmount;
          if (
            (isUpperCase && shiftedCode > 90) ||
            (!isUpperCase && shiftedCode > 122)
          ) {
            shiftedCode -= 26;
          } else if (
            (isUpperCase && shiftedCode < 65) ||
            (!isUpperCase && shiftedCode < 97)
          ) {
            shiftedCode += 26;
          }
          return String.fromCharCode(shiftedCode);
        }
        return char;
      })
      .join("");
  };

  const handleEncrypt = () => {
    setResult(caesarCipher(text, shift));
  };

  const handleDecrypt = () => {
    setResult(caesarCipher(text, shift, true));
  };

  return (
    <div className="container mt-5">
      <h4>Hier kannst du mit der Caesar-Verschlüsselung experimentieren:</h4>
      <div className="mb-3">
        <label htmlFor="text" className="form-label">
          Text:
        </label>
        <input
          type="text"
          className="form-control"
          id="text"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="shift" className="form-label">
          Verschiebung:
        </label>
        <input
          type="number"
          className="form-control"
          id="shift"
          value={shift}
          onChange={(e) => setShift(parseInt(e.target.value))}
        />
      </div>
      <div className="mb-3">
        <button className="btn btn-primary me-2" onClick={handleEncrypt}>
          Verschlüsseln
        </button>
        <button className="btn btn-secondary" onClick={handleDecrypt}>
          Entschlüsseln
        </button>
      </div>
      <div className="mb-3">
        <label htmlFor="result" className="form-label">
          Ergebnis:
        </label>
        <input
          type="text"
          className="form-control"
          id="result"
          value={result}
          readOnly
        />
      </div>
    </div>
  );
};

export default CaesarCipher;
